// Hiscores of a map from the menu (the trophy on built-in maps), for the current settings.

import { online } from '../online/client';
import { fillBoard } from './boardList';

const $ = (id: string) => document.getElementById(id)!;

export class BoardModal {
  private readonly root = $('boardModal');
  private seq = 0;

  constructor() {
    $('boardClose').addEventListener('click', () => this.close());
    this.root.addEventListener('click', (e) => {
      if (e.target === this.root) this.close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.root.hidden) {
        e.stopPropagation();
        this.close();
      }
    });
  }

  open(board: string, title: string, rules: { key: string; label: string }) {
    const seq = ++this.seq;
    $('boardTitle').textContent = title;
    $('boardRules').textContent =
      rules.label +
      (board.startsWith('m:')
        ? " · map files aren't on the server, so these times aren't checked"
        : ' · times are checked by the server');
    const list = $('boardList');
    list.textContent = '';
    $('boardNote').textContent = 'Loading hiscores…';
    this.root.hidden = false;
    $('boardClose').focus();
    online
      .board(board, rules.key, 25)
      .then((b) => {
        if (seq !== this.seq) return;
        fillBoard(list, b, online.me?.name.toLowerCase(), online.me?.name);
        $('boardNote').textContent = b.top.length
          ? `${b.total} player${b.total === 1 ? '' : 's'}${online.me ? '' : ' · pick a hiscore name in Settings to join'}`
          : 'No times with these settings yet. Be the first!';
      })
      .catch((e: Error) => {
        if (seq === this.seq) $('boardNote').textContent = e.message;
      });
  }

  close() {
    this.root.hidden = true;
  }
}
